














import Vue from 'vue';

export default Vue.extend({
	name: 'FeedbackRating',
	props: {
		rating: { type: Number },
	},
	methods: {
		showQueWiseAvgData() {
			this.$emit('show:quessummerytiondialog', false);
		},
	},
});
